/**
 * @fileoverview Clickable div component React interface.
 */
// @ts-nocheck
import {Clickable} from '/ui/components/clickable/clickable';

/** @type {?} */
export const ClickableDiv = React.forwardRef(function(props, ref) {
  const classNames = props.onClick
    ? [props.className, 'clickable'].join(' ')
    : props.className;
  props = {...props, className: classNames};
  return <Clickable tag="div" {...props} ref={ref}/>;
});
